import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useQuery, useQueryClient } from "react-query";
import { AddressType } from "../type/RegistrationDataType";
import { ResponseType } from "../../../../Types/ServicesType/servicesType";
import { getContactTypes, getRelations } from "../registrationServices";

import {
  EmergencyContactFormType,
  initialRegistrationData,
} from "../type/RegistrationModel";
import { RegistrationContext } from "../Registrationform";

const EmergencyContact: React.FC = () => {
  const queryClient = useQueryClient();
  const { emergencyContact, setEmergencyContact } =
    useContext(RegistrationContext);
  const addressTypes = queryClient.getQueryData([
    "getAddressType",
  ]) as ResponseType<AddressType[] | null>;

  const { data: contactTypes, isLoading: contactTypesLoading } = useQuery(
    ["getContactTypes"],
    getContactTypes,
    { refetchOnWindowFocus: false }
  );
  const { data: relations, isLoading: relationsLoading } = useQuery(
    ["getRelations"],
    getRelations,
    { refetchOnWindowFocus: false }
  );

  const handleAddEmergencyContact = () => {
    if (emergencyContact.length < 2) {
      const contact = (
        initialRegistrationData.emergencyContact as EmergencyContactFormType[]
      )[0];
      setEmergencyContact((prev) => [...prev, contact]);
      console.log([contact])
    }
  };

  const handleValueChange = (field:string,value:any,index:number)=>{
    
    const updated = [...emergencyContact]
    const data = {...emergencyContact[index]}
    data[field as keyof typeof data] = value 
    updated[index] = data 
    console.log(index,);
      setEmergencyContact(updated)
  }

useEffect(()=>{
  console.log("contactTypes",contactTypes)
},[contactTypes])

  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={
            <IconButton>
              <ExpandMoreIcon />
            </IconButton>
          }
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <div className="flex gap-2">
            <Typography variant="h6"> Emergency Contact </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="hidden">
            {/* <CustomFormField
         control={control}
         name="isEmergencyContact"
         rules={{required:false}}
         element="input"
         fieldProps={{label:""}}
         /> */}
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div className="col-span-full">
              <Button onClick={handleAddEmergencyContact}>add</Button>
            </div>
            {emergencyContact.map((field, index) => (
              <div
                className="p-3 grid grid-cols-2 gap-3"
                key={`emergencyContact${index}`}
              >
                <div className="col-span-full">
                  Emergency Contact {index + 1}
                </div>
                <Autocomplete
                  loading={contactTypesLoading}
                  value={field?.contactType?.contactrollId ?{
                    contactrollName: field?.contactType?.contactrollName || "",
                    contactrollId: field?.contactType?.contactrollId || 0,
                  }: null}
                  onChange={(_,value)=>{handleValueChange("contactType",value,index)}}
                  options={contactTypes?.response || []}
                  getOptionLabel={(option) => option.contactrollName}
                  isOptionEqualToValue={(option, value) =>
                    option.contactrollId == value.contactrollId
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Contact type" />
                  )}
                />
                <TextField onChange={(e)=>{handleValueChange("givenName",e.target.value,index)}} value={field?.givenName || ""} label="Given name" />
                <TextField onChange={(e)=>{handleValueChange("familyName",e.target.value,index)}} value={field?.familyName || ""} label="Family name" />
                <TextField onChange={(e)=>{handleValueChange("mobileNumber",e.target.value,index)}} value={field?.mobileNumber || "" } type="number" label="Mobile number"  inputProps={{ maxLength: 13 }}/>
                <Autocomplete
                  value={field?.addressType?.id ? {id:0,addressType:field.addressType.addressType} : null}
                  options={addressTypes?.response || []}
                  onChange={(_,value)=>{handleValueChange("addressType",value,index)}}
                  getOptionLabel={option=>option.addressType}
                  isOptionEqualToValue={(option,value)=>option.id == value.id}
                  renderInput={(params) => (
                    <TextField {...params} label="Address type" />
                  )}
                />
                <Autocomplete
                 value={field?.relation?.relationId ? {relationId:field?.relation?.relationId,relationName:field?.relation?.relationName} : null}
                  loading={relationsLoading}
                  options={relations?.response || []}
                  onChange={(_,value)=>{handleValueChange("relation",value,index)}}
                  getOptionLabel={option=>option.relationName}
                  isOptionEqualToValue={(option,value)=>option.relationId == value.relationId}
                  renderInput={(params) => (
                    <TextField {...params} label="Relation with patient" />
                  )}
                />
                <TextField onChange={(e)=>{handleValueChange("streetAddress",e.target.value,index)}} value={field?.streetAddress || ""} label="Street address" />
                <TextField onChange={(e)=>{handleValueChange("address",e.target.value,index)}} value={field?.address || ""} label="Address" />
              </div>
            ))}
          </div>
        </AccordionDetails>
      </Accordion>

      {/* </Paper> */}
    </div>
  );
};

export default EmergencyContact;
